import React, { Component } from 'react'
import { SubsidiaryDataContext } from './withAuth'

export default function withSubsidiary(ComponentWithSubsidiary) {
    return class extends Component {
        static contextType = SubsidiaryDataContext
        render() {
            return (
                <ComponentWithSubsidiary
                    subsidiaryData={this.context}
                    {...this.props}
                />
            )
        }
    }
}
